import PropTypes from "prop-types";

import AuthInputTooltip from "./auth_input_tooltip";

const TextField = ({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  autoComplete,
  required = true,
  tooltipTitle,
  tooltipBody,
  inputRef,
}) => {
  const input = (
    <input
      ref={inputRef}
      id={id}
      name={name}
      type="text"
      className="form-control"
      placeholder={placeholder}
      value={value}
      required={required}
      autoComplete={autoComplete}
      aria-label={label}
      onChange={(event) => onChange(event.target.value)}
    />
  );

  return tooltipTitle && tooltipBody ? (
    <div className="auth-input-wrap position-relative mb15">
      {input}
      <span className="position-absolute auth-email-tooltip">
        <AuthInputTooltip title={tooltipTitle} body={tooltipBody} />
      </span>
    </div>
  ) : (
    <div className="auth-input-wrap position-relative mb15">{input}</div>
  );
};

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  autoComplete: PropTypes.string.isRequired,
  required: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  tooltipBody: PropTypes.string,
  inputRef: PropTypes.shape({ current: PropTypes.any }),
};

export default TextField;
